import React from 'react';
import styled from 'styled-components';
import { isFunction } from 'lodash-es';
import HBText from '../HBText/HBText';
import { flexCenterVertical } from '../../styles/mixins';

const HBNewTableSelectableHeader = ({ selectableProps }) => {
    const showHeaderWrapper =
        !selectableProps?.showTableHeaderOnSelect &&
        selectableProps?.selectedItemIds?.length > 0;

    const countItemsSelected = selectableProps.selectedItemIds.length;
    const showBulkActions = isFunction(
        selectableProps?.renderBulkActionsComponent
    );
    const selectedText = `${countItemsSelected} SELECTED${
        showBulkActions ? ': BULK ACTIONS' : ''
    }`;

    return (
        <Container>
            {showHeaderWrapper && (
                <HeaderWrapper>
                    <HeaderLeftWrapper>
                        <HBText type="subtitle12" color="text.secondary">
                            {selectedText}
                        </HBText>
                        {showBulkActions &&
                            selectableProps.renderBulkActionsComponent()}
                    </HeaderLeftWrapper>
                </HeaderWrapper>
            )}
        </Container>
    );
};

export default React.memo(HBNewTableSelectableHeader);

// -------------------------------- Styles -------------------------------- //
const Container = styled.div`
    ${flexCenterVertical}
    position: absolute;
    height: 30px;
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding-left: 48px;
    height: 30px;
`;

const HeaderLeftWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;
